import Logo from "../assets/images/Logo.webp";
import mySelf from "../assets/images/Graduated.webp";
import Sahii from "../assets/images/Sahii.webp";
import ConvoGPT from "../assets/images/Convo-GPT.webp";
import Appointify from "../assets/images/Appointify.png";
import ComingSoon from "../assets/images/ComingSoon.jpeg";
import BlogBlast from "../assets/images/BlogBlast.png";
import Peregrine from "../assets/images/Peregrine.jpg";
import TCT from "../assets/images/TCT.png";
import Week1 from "../assets/images/week1.jpeg";
import Week2 from "../assets/images/week2.jpeg";
import Week3 from "../assets/images/Week3.jpg";
import Week4 from "../assets/images/Week4.png";
import Week5 from "../assets/images/Week5.jpeg";
import Week6 from "../assets/images/Week6.png";
import Week7 from "../assets/images/WEEK7.jpeg";
import Week8 from "../assets/images/WEEK8.jpeg";
import Week9 from "../assets/images/WEEK9.png";
import Week10 from "../assets/images/Week10.jpeg";
import Week11 from "../assets/images/Week11.jpeg";
import Week12 from "../assets/images/WEEK12.png";

const Images = {
  Logo,
  mySelf,
  Sahii,
  ConvoGPT,
  Appointify,
  ComingSoon,
  BlogBlast,
  Peregrine,
  TCT,
  Week1,
  Week2,
  Week3,
  Week4,
  Week5,
  Week6,
  Week7,
  Week8,
  Week9,
  Week10,
  Week11,
  Week12,
};

export default Images;
